import React, { useState, useRef, useEffect } from 'react'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import { Typeahead } from 'react-bootstrap-typeahead'
import {
  getZonesResponsable,
  getPreAssignedResponsible,
  getResponsableInsured,
  getCBZones,
  getCBIsured
} from '../../store/actions'
import { connect } from 'react-redux'
import { Form, FormControl, InputGroup, Row } from 'react-bootstrap'
import { LoadingComponent } from 'recupero-comunes'

const MySearch = (props) => {
  const dataCase = props.gestionCase
  const [isCheckedModeSelection, setIsCheckedModeSelection] = useState(true)
  const [isRadioZone, setIsRadioZone] = useState(true)
  const [isRadioInsured, setIsRadioInsured] = useState(true)
  const refZone = useRef(null)
  const refInsuredRequest = useRef(null)
  const [zona, setZona] = useState(dataCase.CodZona)
  const [idResponsable, setIdResponsable] = useState('')
  const [loading, setLoading] = useState(false)
  const [isCheckedJUD, setIsCheckedJUD] = useState(false)
  const [isCheckedEJUD, setIsCheckedEJUD] = useState(false)
  const [isCheckedSolAseg, setIsCheckedSolAseg] = useState(true)

  const handleClear = (id) => {
    switch (id) {
      case 'zone':
        setZona('')
        refZone.current.clear()
        break
      case 'insured':
        setIdResponsable('')
        refInsuredRequest.current.clear()
        props.setRespSolicitudAseg({});
        break
    }
    props.setDataTable(props.dataOriginal)
  }

  const onsubmitCb = (e, cb) => {
      
    if (cb === 'zone') {
      setLoading(true)  
      props.dataApi.data = []
      props.onGetZonesResponsable({ zona: e[0].id, idCaso: dataCase.IdCaso })
      setZona(e[0].id)
    } else {
      props.setRespSolicitudAseg(e[0]);
      //props.onGetPreAssignedResponsible({ idResponsable: e[0].id })      
      //props.onGetZonesResponsable({ zona: zona, idCaso: dataCase.IdCaso })
      //setIdResponsable(e[0].id)
    }
  }

  const handleOnChange = (value) => {
    switch (value) {
      case 'checkbox':
        setIsCheckedModeSelection(!isCheckedModeSelection)
        setIsRadioZone(false)
        if (!isCheckedModeSelection) {
          window.location.reload(false)
        }
        break
      case '218001':
        props.setmodeAssignated('218001')
        props.setDataTable(props.dataApi.assignatdInsured)
        setIsRadioZone(true)
        setIsRadioInsured(true)
        break
      case '218002':
        setLoading(true)
        props.setmodeAssignated('218002')
        if (idResponsable === '') {
          props.setDataTable(props.dataOriginal)
          setLoading(false)
        } else {
          props.onGetZonesResponsable({
            idCaso: dataCase.IdCaso,
            zona: zona
          })
        }
        setIsRadioZone(false)
        setIsRadioInsured(true)
        props.setDataTable(props.dataApi.data)
        break
      case '218004':
        setLoading(true)
        props.setmodeAssignated('218004')
        /*if (idResponsable === '') {
          props.setDataTable(props.dataOriginal)
          setLoading(false)
        } else {
          props.onGetPreAssignedResponsible({
            idResponsable: idResponsable
          })
        }*/
        props.setDataTable(props.dataApi.data)
        setIsRadioZone(true)
        setIsRadioInsured(false)
        setLoading(false)
        break
    }
  }

  const handleOnChangeJUD = () => {
    setIsCheckedJUD(!isCheckedJUD)
    if (!isCheckedJUD) {
      props.setCellColums('JUD')
    } else {
      props.setCellColums('TOTAL')
    }
  }

  const handleOnChangeEJUD = () => {
    setIsCheckedEJUD(!isCheckedEJUD)
    if (!isCheckedEJUD) {
      props.setCellColums('EJUD')
    } else {
      props.setCellColums('TOTAL')
    }
  }
  const handleOnChangeSolAseg = () => {
    handleClear('insured');
    setIsCheckedSolAseg(!isCheckedSolAseg)
  }

  useEffect(() => {
    if (dataCase.CodZona) {
      props.onGetZonesResponsable({
        idCaso: dataCase.IdCaso,
        zona: dataCase.CodZona
      })
    }
    if (dataCase?.IdRecuperaPreAsig) {
      props.onGetResponsableInsured({
        idResponsable: dataCase.IdRecuperaPreAsig
      })
    }
    props.onGetCBIsured({
      idOrganizacion: dataCase?.Compania,
      rol: '70ABOEXSOAS', //'0070ABOEXT',
      tipoPersona: '0080PROVE00'
    })
    props.onGetCBZones({
      concepto: '224'
    })
  }, [])

  useEffect(() => {
    props.setDataTable(props.dataApi.data)
    setLoading(false)
  }, [props.dataApi.data])

  return (
    <div>
      <LoadingComponent show={loading || props.dataApi.loading} />
      <Form.Group
        name='radioButtons'
        className='row'
        onChange={(e) => handleOnChange(e.target.value)}
      >
        <Col md='3'>
          <Form.Label>{props.formLabel['asigcaso-lbl-preasignado']}</Form.Label>
          <InputGroup className='mb-3'>
            <InputGroup.Radio
              name='radioButtons'
              value='218001'
              disabled={isCheckedModeSelection}
            />
            <FormControl value={dataCase?.RecuperadoPreasig} disabled />
          </InputGroup>
        </Col>

        <Col md='3'>
          <Form.Label>{props.formLabel['asigcaso-cmb-zona']}</Form.Label>
          <InputGroup>
            <InputGroup.Radio
              name='radioButtons'
              value='218002'
              defaultChecked={isCheckedModeSelection}
              disabled={isCheckedModeSelection}
            />
            {props.dataApi.cbZones.length > 0 ? (
              <Typeahead
                ref={refZone}
                id='zone'
                onChange={(e) => {
                  onsubmitCb(e, 'zone')
                }}
                defaultInputValue={
                  props.dataApi.cbZones.find(
                    (item) => item.id === dataCase?.CodZona
                  )?.nombre
                }
                labelKey='nombre'
                options={props.dataApi.cbZones ? props.dataApi.cbZones : []}
                disabled={isRadioZone}
              />
            ) : null}
            <InputGroup.Text onClick={() => handleClear('zone')}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                className='bi bi-x'
                viewBox='0 0 16 16'
              >
                <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
              </svg>
            </InputGroup.Text>
          </InputGroup>
        </Col>

        <Col md='2' className='mt-1'>
          <Form.Label>
            {props.formLabel['asigcaso-chk-modseleccion']}
          </Form.Label>
          <Form.Check
            type='checkbox'
            value='checkbox'
            defaultChecked={isCheckedModeSelection}
            label={
              isCheckedModeSelection
                ? props.formLabel['asigcaso-lbl-modoSelecA']
                : props.formLabel['asigcaso-lbl-modoSelecM']
            }
          />
        </Col>
        <Col md='4'>
          <Form.Label>
            {props.formLabel['asigcaso-cmb-solicitudAseg']}
          </Form.Label>          
          <InputGroup>
            <InputGroup.Checkbox 
              name='checks'
              value='218004'
              onChange={handleOnChangeSolAseg}
            />                   
            <Typeahead
              ref={refInsuredRequest}
              id='insuredRequest'
              onChange={(e) => {
                onsubmitCb(e, 'insuredRequest')
              }}
              labelKey='nombre'
              options={props.dataApi.cbInsured ? props.dataApi.cbInsured : []}
              disabled={isCheckedSolAseg}
            />

            <InputGroup.Text onClick={() => handleClear('insured')}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                className='bi bi-x'
                viewBox='0 0 16 16'
              >
                <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
              </svg>
            </InputGroup.Text>
          </InputGroup>
        </Col>
      </Form.Group>
      <Row
        className='m-4 float-right'
        style={{
          float: 'Right'
        }}
      >
        <Col md='5' className='mt-1'>
          <Form.Label>
            {props.formLabel['asigcaso-grilla-ult12meses']}
          </Form.Label>
        </Col>
        <Col md='3' className='mt-1'>
          <Form.Check
            onChange={handleOnChangeJUD}
            label={props.formLabel['asigcaso-chk-judicial']}
          />
        </Col>
        <Col md='4' className='mt-1'>
          <Form.Check
            onChange={handleOnChangeEJUD}
            label={props.formLabel['asigcaso-chk-extrajudicial']}
          />
        </Col>
      </Row>
    </div>
  )
}

const mapStateToProps = (state) => ({
  dataApi: state.assignated
})
const mapDispatchToProps = (dispatch) => ({
  onGetZonesResponsable: (query) => dispatch(getZonesResponsable(query)),
  onGetPreAssignedResponsible: (query) =>
  dispatch(getPreAssignedResponsible(query)),
  onGetCBIsured: (query) => dispatch(getCBIsured(query)),
  onGetCBZones: (query) => dispatch(getCBZones(query)),
  onGetResponsableInsured: (query) => dispatch(getResponsableInsured(query))
})

export default connect(mapStateToProps, mapDispatchToProps)(MySearch)
